import styled from '@emotion/styled';
import { Link as LinkBase } from 'react-router-dom';

export const Link = styled(LinkBase)`
  display: flex;
  justifycontent: center;
  alignitems: center;
`;
